import { useLang } from "@/i18n";

const DOORS = [
  { id: "owners", key: "owner", testId: "door-a-card", door: "Owner", eyebrowKey: "doorA.eyebrow", titleKey: "doorA.title", copyKey: "doorA.copy" },
  { id: "developers", key: "developer", testId: "door-b-card", door: "Developer", eyebrowKey: "doorB.eyebrow", titleKey: "doorB.title", copyKey: "doorB.copy" },
  { id: "acquirers", key: "acquirer", testId: "door-c-card", door: "Acquirer", eyebrowKey: "doorC.eyebrow", titleKey: "doorC.title", copyKey: "doorC.copy", quiet: true },
];

const DoorCard = ({ door, onBook, onLead, delay }) => {
  const { t } = useLang();
  const go = () =>
    document.getElementById(door.id)?.scrollIntoView({ behavior: "smooth" });
  const quiet = door.quiet;
  return (
    <div
      data-testid={door.testId}
      onClick={go}
      style={{ animationDelay: `${delay}s` }}
      className={`hero-reveal group cursor-pointer border transition-colors duration-300 hover:border-[#B8894B]/70 flex flex-col justify-between ${
        quiet
          ? "border-[#1A2A24] bg-transparent p-6 md:p-8 md:col-span-2 md:flex-row md:items-center md:gap-10"
          : "border-[#1A2A24] bg-[#131F1A] p-8 md:p-12"
      }`}
    >
      <div className={quiet ? "md:max-w-2xl" : ""}>
        <p className="font-mono-label text-[10px] tracking-[0.3em] uppercase text-[#B8894B]">
          {t(door.eyebrowKey)}
        </p>
        <h3
          className={`font-display tracking-tight text-[#EDE7DA] mt-4 ${
            quiet ? "text-xl md:text-2xl" : "text-3xl md:text-4xl"
          }`}
        >
          {t(door.titleKey)}
        </h3>
        <p
          className={`font-light text-[#EDE7DA]/65 leading-relaxed mt-4 ${
            quiet ? "text-sm" : "text-base"
          }`}
        >
          {t(door.copyKey)}
        </p>
      </div>
      <div className={`flex flex-wrap items-center gap-3 ${quiet ? "mt-6 md:mt-0 md:shrink-0" : "mt-10"}`}>
        <button
          type="button"
          data-testid={`${door.testId}-book-call-cta`}
          onClick={(e) => {
            e.stopPropagation();
            onBook(door.door);
          }}
          className="font-mono-label text-[10px] tracking-[0.2em] uppercase border border-[#B8894B] text-[#B8894B] px-5 py-2.5 hover:bg-[#B8894B] hover:text-[#0E1613] transition-colors duration-300"
        >
          {t("cta.bookCall")}
        </button>
        <button
          type="button"
          data-testid={`${door.testId}-whatsapp-cta`}
          onClick={(e) => {
            e.stopPropagation();
            onLead(door.key);
          }}
          className="font-mono-label text-[10px] tracking-[0.2em] uppercase border border-[#1A2A24] text-[#EDE7DA]/70 px-5 py-2.5 hover:border-[#5E8570] hover:text-[#EDE7DA] transition-colors duration-300"
        >
          {t("cta.whatsapp")}
        </button>
      </div>
    </div>
  );
};

export const Hero = ({ onBook, onLead }) => {
  const { t } = useLang();
  return (
    <section
      data-testid="hero-section"
      className="min-h-screen flex flex-col justify-center max-w-7xl mx-auto px-6 md:px-10 pt-32 pb-20"
    >
      <p
        className="hero-reveal font-mono-label text-[10px] md:text-xs tracking-[0.3em] uppercase text-[#B8894B]"
        style={{ animationDelay: "0.1s" }}
      >
        {t("hero.eyebrow")}
      </p>
      <h1
        className="hero-reveal font-display text-4xl sm:text-5xl lg:text-6xl tracking-tight text-[#EDE7DA] leading-[1.08] mt-6 max-w-4xl"
        style={{ animationDelay: "0.25s" }}
      >
        {t("hero.h1a")} <em className="italic text-[#B8894B]">{t("hero.h1em1")}</em>
        {t("hero.h1b")} <em className="italic text-[#B8894B]">{t("hero.h1em2")}</em>
        {t("hero.h1c")}
      </h1>
      <p
        className="hero-reveal font-light text-base md:text-lg text-[#EDE7DA]/65 leading-relaxed mt-6 max-w-2xl"
        style={{ animationDelay: "0.4s" }}
      >
        {t("hero.sub")}
      </p>
      <div className="grid md:grid-cols-2 gap-4 mt-14">
        {DOORS.map((door, i) => (
          <DoorCard
            key={door.id}
            door={door}
            onBook={onBook}
            onLead={onLead}
            delay={0.55 + i * 0.15}
          />
        ))}
      </div>
    </section>
  );
};
